export default {
  title: "Contacten overzicht",
  noRecords: "Geen contacten gevonden",
}
